import ContentServiceClient from "../clients/ContentServiceClient";
import * as TrackingUtil from "../utils/TrackingUtil";

import SitecoreFooterActions from "../actions/SitecoreFooterActions";
import { SessionStore } from "../uidispatcherapi/SessionStore";

import { Store } from "../utils/Store";

import { Footer } from "../datatypes/Footer";

type State = {
    locale: string | null | undefined;
    country: string | null | undefined;
    footer: Footer | null | undefined;
    loading: boolean;
    error: boolean;
};

let state: State;

class SitecoreFooterImpl extends Store {
    constructor() {
        super();
        state = this.getEmptyState();
        this.listenTo(SitecoreFooterActions.loadFooter, this.loadFooter);
        this.listenTo(SessionStore, this.loadFooter);
        this.loadFooter();
    }

    loadFooter() {
        if (SessionStore.pending()) {
            return;
        }
        const locale: string = SessionStore.getLocale();
        const country: string = SessionStore.getCountry();
        const isSameFooter = state.footer && state.locale === locale && state.country === country;
        if (!state.loading && !isSameFooter) {
            state.loading = true;
            this.trigger();
            ContentServiceClient.getSitecoreFooter(country, locale)
                .then(response => this.footerLoadSuccess(response, country, locale))
                .catch(error => this.footerLoadFail(error));
        } else if (isSameFooter) {
            state.error = false;
            this.trigger();
        }
    }

    footerLoadSuccess(response: Footer, country: string, locale: string) {
        state = {
            country,
            locale,
            footer: response,
            loading: false,
            error: false
        };

        this.trigger();
    }

    footerLoadFail(error: any) {
        TrackingUtil.trackUIError("SitecoreFooter", "Loading of footer failed.", error);
        state.loading = false;
        state.error = true;
        this.trigger();
    }

    getEmptyState() {
        return {
            country: undefined,
            locale: undefined,
            footer: undefined,
            loading: false,
            error: false
        };
    }

    getState() {
        return state;
    }

    /**
     * For testing purpose.
     */
    resetData() {
        state = this.getEmptyState();
    }
}

export const SitecoreFooterStore = new SitecoreFooterImpl();
